export default __webpack_public_path__ + "static/media/logo-cgl.c3d874d9.png";